module.exports = __webpack_public_path__ + "static/media/core3.1026d9c2.png";